// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2001":"17d2ede36b187547","2218":"cb5fe395de8423ed","5628":"abd7b3c8c8a3bafe","7826":"656a681916d02b48","8072":"fde45b7613fcfbbc","9870":"29710c9f91914321"}[chunkId] + ".css";
};